import { WRITE_MESSAGE } from "./constants";

export const UserMessage = (state = { message: "" }, action) => {
  switch (action.type) {
    case WRITE_MESSAGE:
      return action.payload.message;
    default:
      return { ...state };
  }
};
